// extracted by mini-css-extract-plugin
export default {"plateDescription":"aeP6cS"};